import api, { ApiCallReturn } from '../api';

export const getAppConfig = (): ApiCallReturn => api.get('/web/pages/config');
export const getInitApp = (): ApiCallReturn => api.get('/web/pages/init');
